<ng-container *ngIf="ready && (isFirstPage$ | async)">
  <h2 class="mw568 tc firstHeading">
    {{ headerText }}
  </h2>
</ng-container>
<ng-container *ngIf="ready && (isFirstPage$ | async) === false">
  <div
    class="stepHeading"
    [ngClass]="{
      tenSteps: headerNumber && headerNumber > 9,
      noCounter: !headerNumber
    }"
  >
    <h1 class="ng-binding mw568" dir="{{ dir$ | async }}">
      <span
        class="ng-binding"
        *ngIf="headerNumber && headerNumber > 0 && (isForm$ | async) === false"
        >{{ headerNumber }}</span
      >
      {{ headerText }}
    </h1>
  </div>
</ng-container>
